import { Tabs } from 'antd';
import { useSearchParams } from 'react-router-dom';
import useTranslation from '../../../hooks/translation/useTranslation';
import './Profile.scss';
import { ReactComponent as Group } from '../../../../resources/images/svg/group.svg';
import { ReactComponent as PurchasedTicketIcon } from '../../../../resources/images/svg/purchasedTicket.svg';
import { ReactComponent as RefundedTicketIcon } from '../../../../resources/images/svg/refundedTicket.svg';
import { ReactComponent as PaymentCard } from '../../../../resources/images/svg/paymentCard.svg';
import { ReactComponent as Account } from '../../../../resources/images/svg/account.svg';
// import { ReactComponent as BookedTicket } from '../../../../r
// esources/images/svg/bookedTicket.svg';
import ProfileData from './components/ProfileData';
import PurchasedTickets from './components/purchasedTickets/PurchasedTickets';
import SavedPassengers from './components/savedPassengers/SavedPassengers';
import RefundedTickets from './components/refundedTickets/RefundedTickets';
import PaymentCards from './components/paymentCards/PaymentCards';
// import BookedStatements from './components/bookedStatements/BookedStatements';

const tabTitleClass = 'm-0 text-base leading-[26px]';
const buttonClass = 'border-0 bg-transparent cursor-pointer flex gap-[10px] items-center';

function Profile() {
  const { trans } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const changeQuery = (value) => {
    setSearchParams({ tab: value });
  };

  const items = [
    {
      key: 'profile',
      label:
  <button className={buttonClass} onClick={() => changeQuery('profile')} type="button">
    <Account className="h-5 w-5" />
    <h3 className={tabTitleClass}>{trans('profile')}</h3>
  </button>,
      children: <ProfileData />,
    },
    {
      key: 'purchased-tickets',
      label:
  <button className={buttonClass} onClick={() => changeQuery('purchased-tickets')} type="button">
    <PurchasedTicketIcon className="h-5 w-5" />
    <h3 className={tabTitleClass}>{trans('purchased_tickets')}</h3>

  </button>,
      children: <PurchasedTickets />,
    },
    {
      key: 'refunded-tickets',
      label:
  <button className={buttonClass} onClick={() => changeQuery('refunded-tickets')} type="button">
    <RefundedTicketIcon className="h-5 w-5" />
    <h3 className={tabTitleClass}>{trans('refunded_tickets')}</h3>
  </button>,
      children: <RefundedTickets />,
    },
    //   (user?.type === 'legal' && {
    //     key: 'booked-statements',
    //     label:
    // <button
    //   className={buttonClass}
    //   onClick={() => changeQuery('booked-statements')}
    //   type="button"
    // >
    //   <BookedTicket className="h-5 w-5" />
    //   <h3 className={tabTitleClass}>{trans('reservations')}</h3>
    // </button>,
    //     children: <BookedStatements />,
    //   }),
    {
      key: 'saved-passengers',
      label:
  <button className={buttonClass} onClick={() => changeQuery('saved-passengers')} type="button">
    <Group className="h-5 w-5" />
    <h3 className={tabTitleClass}>{trans('saved_passengers')}</h3>
  </button>,
      children: <SavedPassengers />,
    },
    {
      key: 'payment-cards',
      label:
  <button className={buttonClass} onClick={() => changeQuery('payment-cards')} type="button">
    <PaymentCard className="h-5 w-5" />
    <h3 className={tabTitleClass}>{trans('payment_card')}</h3>
  </button>,
      children: <PaymentCards />,
    },
  ];

  return (
    <Tabs activeKey={searchParams.get('tab') || 'profile'} items={items} className="profile-tabs text-gray-ch" />
  );
}

export default Profile;
